<template>
  <div>
    <!-- filters -->
    <div class="mb-4">
      <Filters @applyFilters="pushFilters($event)"></Filters>
    </div>
  </div>
</template>

<script>
import Filters from './Filters.vue'

export default {
  components: {
    Filters
  },
  data () {
    return {
      filters: {}
    }
  },
  methods: {
    pushFilters (filters) {
      this.filters = { ...filters }
    }
  }
}
</script>
